module.exports = __webpack_public_path__ + "static/media/processing.79a2519a.svg";